module.exports = __webpack_public_path__ + "static/media/camera3.e05fb5f5.png";